/**
 * PB Pick & Mix — mouse parallax on the floating product photos in the hero
 *
 * Loaded with sections/pb-pick-mix-bundle-planetb.liquid when the parallax
 * setting is on. Sets --pm-x and --pm-y (-1…1, centre = 0) on the hero; the CSS
 * turns that into an offset per photo, larger the closer the photo sits
 * (.pb-pm__floater-depth). Only with a real mouse on desktop, and never with
 * 'reduce motion'. The floating itself is pure CSS.
 */
(function () {
  const HERO_SELECTOR = '[data-pm-hero-parallax]';
  const pointerQuery = window.matchMedia('(min-width: 991px) and (hover: hover) and (pointer: fine)');
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function canParallax() {
    return pointerQuery.matches && !motionQuery.matches;
  }

  function reset(hero) {
    hero.style.setProperty('--pm-x', '0');
    hero.style.setProperty('--pm-y', '0');
  }

  function bind(hero) {
    if (hero.dataset.pmParallaxBound === 'true') return;
    hero.dataset.pmParallaxBound = 'true';

    let frame = 0;
    let x = 0;
    let y = 0;

    // One update per frame, however often mousemove fires.
    hero.addEventListener('mousemove', (event) => {
      if (!canParallax()) return;

      const rect = hero.getBoundingClientRect();
      x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      y = ((event.clientY - rect.top) / rect.height) * 2 - 1;

      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        hero.style.setProperty('--pm-x', x.toFixed(3));
        hero.style.setProperty('--pm-y', y.toFixed(3));
      });
    });

    hero.addEventListener('mouseleave', () => {
      cancelAnimationFrame(frame);
      frame = 0;
      reset(hero);
    });
  }

  function init() {
    for (const hero of document.querySelectorAll(HERO_SELECTOR)) bind(hero);
  }

  // If someone switches to 'reduce motion' mid-visit, put everything back.
  motionQuery.addEventListener('change', () => {
    if (motionQuery.matches) {
      for (const hero of document.querySelectorAll(HERO_SELECTOR)) reset(hero);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: the section re-renders on every setting change.
  document.addEventListener('shopify:section:load', init);
})();
